// CBSA (Core Based Statistical Area) FIPS Codes
// Source: U.S. Census Bureau / NBER Crosswalk (July 2023)
// Official OMB Delineations

// CBSA Code -> Metropolitan/Micropolitan Area Title
export const cbsaToMetro: Record<string, string> = {
  "10100": "Aberdeen, SD",
  "10140": "Aberdeen, WA",
  "10180": "Abilene, TX",
  "10220": "Ada, OK",
  "10300": "Adrian, MI",
  "10380": "Aguadilla, PR",
  "10420": "Akron, OH",
  "10460": "Alamogordo, NM",
  "10480": "Alamosa, CO",
  "10500": "Albany, GA",
  "10540": "Albany, OR",
  "10580": "Albany-Schenectady-Troy, NY",
  "10620": "Albemarle, NC",
  "10660": "Albert Lea, MN",
  "10700": "Albertville, AL",
  "10740": "Albuquerque, NM",
  "10760": "Alexander City, AL",
  "10780": "Alexandria, LA",
  "10820": "Alexandria, MN",
  "10860": "Alice, TX",
  "10900": "Allentown-Bethlehem-Easton, PA-NJ",
  "10940": "Alma, MI",
  "10980": "Alpena, MI",
  "11020": "Altoona, PA",
  "11060": "Altus, OK",
  "11100": "Amarillo, TX",
  "11140": "Americus, GA",
  "11180": "Ames, IA",
  "11200": "Amherst Town-Northampton, MA",
  "11220": "Amsterdam, NY",
  "11260": "Anchorage, AK",
  "11360": "Anderson Creek, NC",
  "11380": "Andrews, TX",
  "11420": "Angola, IN",
  "11460": "Ann Arbor, MI",
  "11500": "Anniston-Oxford, AL",
  "11540": "Appleton, WI",
  "11580": "Arcadia, FL",
  "11620": "Ardmore, OK",
  "11640": "Arecibo, PR",
  "11660": "Arkadelphia, AR",
  "11680": "Arkansas City-Winfield, KS",
  "11700": "Asheville, NC",
  "11740": "Ashland, OH",
  "11820": "Astoria, OR",
  "11860": "Atchison, KS",
  "11900": "Athens, OH",
  "11940": "Athens, TN",
  "11980": "Athens, TX",
  "12020": "Athens-Clarke County, GA",
  "12060": "Atlanta-Sandy Springs-Roswell, GA",
  "12100": "Atlantic City-Hammonton, NJ",
  "12140": "Auburn, IN",
  "12180": "Auburn, NY",
  "12220": "Auburn-Opelika, AL",
  "12260": "Augusta-Richmond County, GA-SC",
  "12300": "Augusta-Waterville, ME",
  "12380": "Austin, MN",
  "12420": "Austin-Round Rock-San Marcos, TX",
  "12460": "Bainbridge, GA",
  "12520": "Baker City, OR",
  "12540": "Bakersfield-Delano, CA",
  "12580": "Baltimore-Columbia-Towson, MD",
  "12620": "Bangor, ME",
  "12660": "Baraboo, WI",
  "12700": "Barnstable Town, MA",
  "12740": "Barre, VT",
  "12780": "Bartlesville, OK",
  "12860": "Batavia, NY",
  "12900": "Batesville, AR",
  "12940": "Baton Rouge, LA",
  "12980": "Battle Creek, MI",
  "13020": "Bay City, MI",
  "13060": "Bay City, TX",
  "13100": "Beatrice, NE",
  "13140": "Beaumont-Port Arthur, TX",
  "13180": "Beaver Dam, WI",
  "13220": "Beckley, WV",
  "13260": "Bedford, IN",
  "13300": "Beeville, TX",
  "13340": "Bellefontaine, OH",
  "13380": "Bellingham, WA",
  "13420": "Bemidji, MN",
  "13460": "Bend, OR",
  "13540": "Bennington, VT",
  "13660": "Big Rapids, MI",
  "13700": "Big Spring, TX",
  "13740": "Billings, MT",
  "13780": "Binghamton, NY",
  "13820": "Birmingham, AL",
  "13860": "Bishop, CA",
  "13900": "Bismarck, ND",
  "13940": "Blackfoot, ID",
  "13980": "Blacksburg-Christiansburg-Radford, VA",
  "14010": "Bloomington, IL",
  "14020": "Bloomington, IN",
  "14100": "Bloomsburg-Berwick, PA",
  "14140": "Bluefield, WV-VA",
  "14180": "Blytheville, AR",
  "14220": "Bogalusa, LA",
  "14260": "Boise City, ID",
  "14300": "Bonham, TX",
  "14380": "Boone, NC",
  "14420": "Borger, TX",
  "14460": "Boston-Cambridge-Newton, MA-NH",
  "14500": "Boulder, CO",
  "14540": "Bowling Green, KY",
  "14580": "Bozeman, MT",
  "14620": "Bradford, PA",
  "14660": "Brainerd, MN",
  "14700": "Branson, MO",
  "14710": "Brattleboro, VT",
  "14720": "Breckenridge, CO",
  "14740": "Bremerton-Silverdale-Port Orchard, WA",
  "14780": "Brenham, TX",
  "14820": "Brevard, NC",
  "14860": "Bridgeport-Stamford-Danbury, CT",
  "14940": "Brigham City, UT-ID",
  "15020": "Brookhaven, MS",
  "15060": "Brookings, OR",
  "15100": "Brookings, SD",
  "15180": "Brownsville-Harlingen, TX",
  "15220": "Brownwood, TX",
  "15260": "Brunswick-St. Simons, GA",
  "15340": "Bucyrus, OH",
  "15380": "Buffalo-Cheektowaga, NY",
  "15420": "Burley, ID",
  "15460": "Burlington, IA-IL",
  "15500": "Burlington, NC",
  "15540": "Burlington-South Burlington, VT",
  "15580": "Butte-Silver Bow, MT",
  "15620": "Cadillac, MI",
  "15660": "Calhoun, GA",
  "15700": "Cambridge, MD",
  "15740": "Cambridge, OH",
  "15780": "Camden, AR",
  "15820": "Campbellsville, KY",
  "15860": "Cañon City, CO",
  "15900": "Canton, IL",
  "15940": "Canton-Massillon, OH",
  "15980": "Cape Coral-Fort Myers, FL",
  "16020": "Cape Girardeau, MO-IL",
  "16060": "Carbondale, IL",
  "16100": "Carlsbad-Artesia, NM",
  "16140": "Carroll, IA",
  "16180": "Carson City, NV",
  "16220": "Casper, WY",
  "16260": "Cedar City, UT",
  "16300": "Cedar Rapids, IA",
  "16340": "Cedartown, GA",
  "16380": "Celina, OH",
  "16460": "Centralia, IL",
  "16500": "Centralia, WA",
  "16540": "Chambersburg, PA",
  "16580": "Champaign-Urbana, IL",
  "16620": "Charleston, WV",
  "16660": "Charleston-Mattoon, IL",
  "16700": "Charleston-North Charleston, SC",
  "16740": "Charlotte-Concord-Gastonia, NC-SC",
  "16820": "Charlottesville, VA",
  "16860": "Chattanooga, TN-GA",
  "16940": "Cheyenne, WY",
  "16980": "Chicago-Naperville-Elgin, IL-IN",
  "17020": "Chico, CA",
  "17060": "Chillicothe, OH",
  "17140": "Cincinnati, OH-KY-IN",
  "17220": "Clarksburg, WV",
  "17260": "Clarksdale, MS",
  "17300": "Clarksville, TN-KY",
  "17340": "Clearlake, CA",
  "17380": "Cleveland, MS",
  "17410": "Cleveland, OH",
  "17420": "Cleveland, TN",
  "17500": "Clewiston, FL",
  "17540": "Clinton, IA",
  "17580": "Clovis, NM",
  "17620": "Coamo, PR",
  "17640": "Coco, PR",
  "17650": "Cody, WY",
  "17660": "Coeur d'Alene, ID",
  "17740": "Coldwater, MI",
  "17780": "College Station-Bryan, TX",
  "17820": "Colorado Springs, CO",
  "17860": "Columbia, MO",
  "17900": "Columbia, SC",
  "17980": "Columbus, GA-AL",
  "18020": "Columbus, IN",
  "18060": "Columbus, MS",
  "18100": "Columbus, NE",
  "18140": "Columbus, OH",
  "18180": "Concord, NH",
  "18220": "Connersville, IN",
  "18260": "Cookeville, TN",
  "18300": "Coos Bay-North Bend, OR",
  "18340": "Corbin, KY",
  "18380": "Cordele, GA",
  "18420": "Corinth, MS",
  "18460": "Cornelia, GA",
  "18500": "Corning, NY",
  "18580": "Corpus Christi, TX",
  "18620": "Corsicana, TX",
  "18660": "Cortland, NY",
  "18700": "Corvallis, OR",
  "18740": "Coshocton, OH",
  "18820": "Crawfordsville, IN",
  "18860": "Crescent City, CA",
  "18880": "Crestview-Fort Walton Beach-Destin, FL",
  "18900": "Crossville, TN",
  "18980": "Cullman, AL",
  "19060": "Cumberland, MD-WV",
  "19100": "Dallas-Fort Worth-Arlington, TX",
  "19140": "Dalton, GA",
  "19180": "Danville, IL",
  "19220": "Danville, KY",
  "19260": "Danville, VA",
  "19300": "Daphne-Fairhope-Foley, AL",
  "19340": "Davenport-Moline-Rock Island, IA-IL",
  "19430": "Dayton-Kettering-Beavercreek, OH",
  "19460": "Decatur, AL",
  "19500": "Decatur, IL",
  "19540": "Decatur, IN",
  "19580": "Defiance, OH",
  "19620": "Del Rio, TX",
  "19660": "Deltona-Daytona Beach-Ormond Beach, FL",
  "19700": "Deming, NM",
  "19740": "Denver-Aurora-Centennial, CO",
  "19760": "DeRidder, LA",
  "19780": "Des Moines-West Des Moines, IA",
  "19810": "Detroit Lakes, MN",
  "19820": "Detroit-Warren-Dearborn, MI",
  "19860": "Dickinson, ND",
  "19940": "Dixon, IL",
  "19980": "Dodge City, KS",
  "20020": "Dothan, AL",
  "20060": "Douglas, GA",
  "20100": "Dover, DE",
  "20140": "Dublin, GA",
  "20180": "DuBois, PA",
  "20220": "Dubuque, IA",
  "20260": "Duluth, MN-WI",
  "20300": "Dumas, TX",
  "20340": "Duncan, OK",
  "20420": "Durango, CO",
  "20460": "Durant, OK",
  "20500": "Durham-Chapel Hill, NC",
  "20540": "Dyersburg, TN",
  "20580": "Eagle Pass, TX",
  "20660": "Easton, MD",
  "20700": "East Stroudsburg, PA",
  "20740": "Eau Claire, WI",
  "20780": "Edwards, CO",
  "20820": "Effingham, IL",
  "20900": "El Campo, TX",
  "20940": "El Centro, CA",
  "20980": "El Dorado, AR",
  "21020": "Elizabeth City, NC",
  "21060": "Elizabethtown, KY",
  "21120": "Elk City, OK",
  "21140": "Elkhart-Goshen, IN",
  "21180": "Elkins, WV",
  "21220": "Elko, NV",
  "21260": "Ellensburg, WA",
  "21300": "Elmira, NY",
  "21340": "El Paso, TX",
  "21380": "Emporia, KS",
  "21420": "Enid, OK",
  "21460": "Enterprise, AL",
  "21500": "Erie, PA",
  "21540": "Escanaba, MI",
  "21580": "Española, NM",
  "21640": "Eufaula, AL-GA",
  "21660": "Eugene-Springfield, OR",
  "21700": "Eureka-Arcata, CA",
  "21740": "Evanston, WY-UT",
  "21780": "Evansville, IN",
  "21820": "Fairbanks-College, AK",
  "21860": "Fairmont, MN",
  "21900": "Fairmont, WV",
  "21980": "Fallon, NV",
  "22020": "Fargo, ND-MN",
  "22060": "Faribault-Northfield, MN",
  "22100": "Farmington, MO",
  "22140": "Farmington, NM",
  "22180": "Fayetteville, NC",
  "22190": "Fayetteville, TN",
  "22220": "Fayetteville-Springdale-Rogers, AR",
  "22260": "Fergus Falls, MN",
  "22300": "Findlay, OH",
  "22340": "Fitzgerald, GA",
  "22380": "Flagstaff, AZ",
  "22420": "Flint, MI",
  "22500": "Florence, SC",
  "22520": "Florence-Muscle Shoals, AL",
  "22540": "Fond du Lac, WI",
  "22580": "Forest City, NC",
  "22620": "Forrest City, AR",
  "22660": "Fort Collins-Loveland, CO",
  "22700": "Fort Dodge, IA",
  "22780": "Fort Leonard Wood, MO",
  "22800": "Fort Madison, IA",
  "22820": "Fort Morgan, CO",
  "22840": "Fort Payne, AL",
  "22900": "Fort Smith, AR-OK",
  "23060": "Fort Wayne, IN",
  "23140": "Frankfort, IN",
  "23180": "Frankfort, KY",
  "23190": "Franklin, KY",
  "23240": "Fredericksburg, TX",
  "23300": "Freeport, IL",
  "23340": "Fremont, NE",
  "23380": "Fremont, OH",
  "23420": "Fresno, CA",
  "23460": "Gadsden, AL",
  "23500": "Gaffney, SC",
  "23540": "Gainesville, FL",
  "23580": "Gainesville, GA",
  "23620": "Gainesville, TX",
  "23660": "Galesburg, IL",
  "23680": "Gallipolis, OH",
  "23700": "Gallup, NM",
  "23780": "Garden City, KS",
  "23820": "Gardnerville Ranchos, NV-CA",
  "23900": "Gettysburg, PA",
  "23940": "Gillette, WY",
  "23980": "Glasgow, KY",
  "24020": "Glens Falls, NY",
  "24100": "Gloversville, NY",
  "24140": "Goldsboro, NC",
  "24180": "Granbury, TX",
  "24220": "Grand Forks, ND-MN",
  "24260": "Grand Island, NE",
  "24300": "Grand Junction, CO",
  "24330": "Grand Rapids, MN",
  "24340": "Grand Rapids-Wyoming-Kentwood, MI",
  "24420": "Grants Pass, OR",
  "24460": "Great Bend, KS",
  "24500": "Great Falls, MT",
  "24540": "Greeley, CO",
  "24580": "Green Bay, WI",
  "24600": "Greencastle, IN",
  "24620": "Greeneville, TN",
  "24640": "Greenfield, MA",
  "24660": "Greensboro-High Point, NC",
  "24700": "Greensburg, IN",
  "24740": "Greenville, MS",
  "24780": "Greenville, NC",
  "24820": "Greenville, OH",
  "24860": "Greenville-Anderson-Greer, SC",
  "24900": "Greenwood, MS",
  "24940": "Greenwood, SC",
  "24980": "Grenada, MS",
  "25020": "Guayama, PR",
  "25060": "Gulfport-Biloxi, MS",
  "25100": "Guymon, OK",
  "25180": "Hagerstown-Martinsburg, MD-WV",
  "25200": "Hailey, ID",
  "25220": "Hammond, LA",
  "25260": "Hanford-Corcoran, CA",
  "25300": "Hannibal, MO",
  "25420": "Harrisburg-Carlisle, PA",
  "25460": "Harrison, AR",
  "25500": "Harrisonburg, VA",
  "25540": "Hartford-West Hartford-East Hartford, CT",
  "25580": "Hastings, NE",
  "25620": "Hattiesburg, MS",
  "25700": "Hays, KS",
  "25720": "Heber, UT",
  "25740": "Helena, MT",
  "25770": "Hemlock Farms, PA",
  "25775": "Henderson, KY",
  "25780": "Henderson, NC",
  "25820": "Hereford, TX",
  "25840": "Hermiston-Pendleton, OR",
  "25850": "Hermitage, PA",
  "25860": "Hickory-Lenoir-Morganton, NC",
  "25880": "Hillsdale, MI",
  "25900": "Hilo-Kailua, HI",
  "25940": "Hilton Head Island-Bluffton-Port Royal, SC",
  "25980": "Hinesville, GA",
  "26020": "Hobbs, NM",
  "26090": "Holland, MI",
  "26140": "Homosassa Springs, FL",
  "26220": "Hood River, OR",
  "26300": "Hot Springs, AR",
  "26340": "Houghton, MI",
  "26380": "Houma-Bayou Cane-Thibodaux, LA",
  "26420": "Houston-Pasadena-The Woodlands, TX",
  "26460": "Hudson, NY",
  "26500": "Huntingdon, PA",
  "26540": "Huntington, IN",
  "26580": "Huntington-Ashland, WV-KY-OH",
  "26620": "Huntsville, AL",
  "26660": "Huntsville, TX",
  "26700": "Huron, SD",
  "26740": "Hutchinson, KS",
  "26780": "Hutchinson, MN",
  "26820": "Idaho Falls, ID",
  "26860": "Indiana, PA",
  "26900": "Indianapolis-Carmel-Greenwood, IN",
  "26980": "Iowa City, IA",
  "27020": "Iron Mountain, MI-WI",
  "27060": "Ithaca, NY",
  "27100": "Jackson, MI",
  "27140": "Jackson, MS",
  "27180": "Jackson, TN",
  "27220": "Jackson, WY-ID",
  "27260": "Jacksonville, FL",
  "27300": "Jacksonville, IL",
  "27340": "Jacksonville, NC",
  "27380": "Jacksonville, TX",
  "27420": "Jamestown, ND",
  "27460": "Jamestown-Dunkirk, NY",
  "27500": "Janesville-Beloit, WI",
  "27540": "Jasper, IN",
  "27600": "Jefferson, GA",
  "27620": "Jefferson City, MO",
  "27700": "Jesup, GA",
  "27740": "Johnson City, TN",
  "27780": "Johnstown, PA",
  "27860": "Jonesboro, AR",
  "27900": "Joplin, MO-KS",
  "27940": "Juneau, AK",
  "27980": "Kahului-Wailuku, HI",
  "28020": "Kalamazoo-Portage, MI",
  "28060": "Kalispell, MT",
  "28100": "Kankakee, IL",
  "28140": "Kansas City, MO-KS",
  "28180": "Kapaa, HI",
  "28260": "Kearney, NE",
  "28300": "Keene, NH",
  "28340": "Kendallville, IN",
  "28380": "Kennett, MO",
  "28420": "Kennewick-Richland, WA",
  "28450": "Kenosha, WI",
  "28500": "Kerrville, TX",
  "28540": "Ketchikan, AK",
  "28580": "Key West-Key Largo, FL",
  "28620": "Kill Devil Hills, NC",
  "28660": "Killeen-Temple, TX",
  "28680": "Kingsland, GA",
  "28700": "Kingsport-Bristol, TN-VA",
  "28740": "Kingston, NY",
  "28780": "Kingsville, TX",
  "28820": "Kinston, NC",
  "28860": "Kirksville, MO",
  "28880": "Kiryas Joel-Poughkeepsie-Newburgh, NY",
  "28900": "Klamath Falls, OR",
  "28940": "Knoxville, TN",
  "29020": "Kokomo, IN",
  "29060": "Laconia, NH",
  "29100": "La Crosse-Onalaska, WI-MN",
  "29180": "Lafayette, LA",
  "29200": "Lafayette-West Lafayette, IN",
  "29260": "La Grande, OR",
  "29300": "LaGrange, GA-AL",
  "29340": "Lake Charles, LA",
  "29380": "Lake City, FL",
  "29420": "Lake Havasu City-Kingman, AZ",
  "29460": "Lakeland-Winter Haven, FL",
  "29470": "Lake of the Woods, VA",
  "29540": "Lancaster, PA",
  "29620": "Lansing-East Lansing, MI",
  "29660": "Laramie, WY",
  "29700": "Laredo, TX",
  "29720": "Lares, PR",
  "29740": "Las Cruces, NM",
  "29780": "Las Vegas, NM",
  "29820": "Las Vegas-Henderson-North Las Vegas, NV",
  "29860": "Laurel, MS",
  "29900": "Laurinburg, NC",
  "29940": "Lawrence, KS",
  "29980": "Lawrenceburg, TN",
  "30020": "Lawton, OK",
  "30060": "Lebanon, MO",
  "30140": "Lebanon, PA",
  "30150": "Lebanon-Claremont, NH-VT",
  "30180": "Le Mars, IA",
  "30260": "Lewisburg, PA",
  "30280": "Lewisburg, TN",
  "30300": "Lewiston, ID-WA",
  "30340": "Lewiston-Auburn, ME",
  "30380": "Lewistown, PA",
  "30420": "Lexington, NE",
  "30460": "Lexington-Fayette, KY",
  "30500": "Lexington Park, MD",
  "30580": "Liberal, KS",
  "30620": "Lima, OH",
  "30660": "Lincoln, IL",
  "30700": "Lincoln, NE",
  "30780": "Little Rock-North Little Rock-Conway, AR",
  "30820": "Lock Haven, PA",
  "30860": "Logan, UT-ID",
  "30900": "Logansport, IN",
  "30980": "Longview, TX",
  "31020": "Longview-Kelso, WA",
  "31060": "Los Alamos, NM",
  "31080": "Los Angeles-Long Beach-Anaheim, CA",
  "31140": "Louisville/Jefferson County, KY-IN",
  "31180": "Lubbock, TX",
  "31220": "Ludington, MI",
  "31260": "Lufkin, TX",
  "31300": "Lumberton, NC",
  "31340": "Lynchburg, VA",
  "31380": "Macomb, IL",
  "31420": "Macon-Bibb County, GA",
  "31500": "Madison, IN",
  "31540": "Madison, WI",
  "31580": "Madisonville, KY",
  "31620": "Magnolia, AR",
  "31680": "Malvern, AR",
  "31700": "Manchester-Nashua, NH",
  "31740": "Manhattan, KS",
  "31820": "Manitowoc, WI",
  "31860": "Mankato, MN",
  "31900": "Mansfield, OH",
  "31930": "Marietta, OH",
  "31940": "Marinette, WI-MI",
  "31980": "Marion, IN",
  "32000": "Marion, NC",
  "32020": "Marion, OH",
  "32060": "Marion-Herrin, IL",
  "32100": "Marquette, MI",
  "32140": "Marshall, MN",
  "32180": "Marshall, MO",
  "32260": "Marshalltown, IA",
  "32280": "Martin, TN",
  "32300": "Martinsville, VA",
  "32340": "Maryville, MO",
  "32380": "Mason City, IA",
  "32390": "Massena-Ogdensburg, NY",
  "32420": "Mayagüez, PR",
  "32460": "Mayfield, KY",
  "32540": "McAlester, OK",
  "32580": "McAllen-Edinburg-Mission, TX",
  "32620": "McComb, MS",
  "32660": "McMinnville, TN",
  "32700": "McPherson, KS",
  "32740": "Meadville, PA",
  "32780": "Medford, OR",
  "32820": "Memphis, TN-MS-AR",
  "32860": "Menomonie, WI",
  "32900": "Merced, CA",
  "32940": "Meridian, MS",
  "33020": "Mexico, MO",
  "33060": "Miami, OK",
  "33100": "Miami-Fort Lauderdale-West Palm Beach, FL",
  "33140": "Michigan City-La Porte, IN",
  "33180": "Middlesborough, KY",
  "33220": "Midland, MI",
  "33260": "Midland, TX",
  "33300": "Milledgeville, GA",
  "33340": "Milwaukee-Waukesha, WI",
  "33380": "Minden, LA",
  "33420": "Mineral Wells, TX",
  "33460": "Minneapolis-St. Paul-Bloomington, MN-WI",
  "33500": "Minot, ND",
  "33540": "Missoula, MT",
  "33580": "Mitchell, SD",
  "33620": "Moberly, MO",
  "33660": "Mobile, AL",
  "33700": "Modesto, CA",
  "33740": "Monroe, LA",
  "33780": "Monroe, MI",
  "33860": "Montgomery, AL",
  "33900": "Monticello, IN",
  "33910": "Monticello, NY",
  "33940": "Montrose, CO",
  "33980": "Morehead City, NC",
  "34020": "Morgan City, LA",
  "34060": "Morgantown, WV",
  "34100": "Morristown, TN",
  "34140": "Moscow, ID",
  "34180": "Moses Lake, WA",
  "34220": "Moultrie, GA",
  "34260": "Mountain Home, AR",
  "34300": "Mountain Home, ID",
  "34340": "Mount Airy, NC",
  "34380": "Mount Pleasant, MI",
  "34420": "Mount Pleasant, TX",
  "34460": "Mount Sterling, KY",
  "34500": "Mount Vernon, IL",
  "34540": "Mount Vernon, OH",
  "34580": "Mount Vernon-Anacortes, WA",
  "34620": "Muncie, IN",
  "34660": "Murray, KY",
  "34680": "Murrells Inlet, SC",
  "34700": "Muscatine, IA",
  "34740": "Muskegon-Norton Shores, MI",
  "34780": "Muskogee, OK",
  "34820": "Myrtle Beach-Conway-North Myrtle Beach, SC",
  "34860": "Nacogdoches, TX",
  "34880": "Nantucket, MA",
  "34900": "Napa, CA",
  "34940": "Naples-Marco Island, FL",
  "34980": "Nashville-Davidson--Murfreesboro--Franklin, TN",
  "35020": "Natchez, MS-LA",
  "35060": "Natchitoches, LA",
  "35100": "New Bern, NC",
  "35140": "Newberry, SC",
  "35220": "New Castle, IN",
  "35300": "New Haven, CT",
  "35340": "New Iberia, LA",
  "35380": "New Orleans-Metairie, LA",
  "35420": "New Philadelphia-Dover, OH",
  "35440": "Newport, OR",
  "35460": "Newport, TN",
  "35580": "New Ulm, MN",
  "35620": "New York-Newark-Jersey City, NY-NJ",
  "35660": "Niles, MI",
  "35700": "Nogales, AZ",
  "35740": "Norfolk, NE",
  "35820": "North Platte, NE",
  "35840": "North Port-Bradenton-Sarasota, FL",
  "35900": "North Wilkesboro, NC",
  "35940": "Norwalk, OH",
  "35980": "Norwich-New London-Willimantic, CT",
  "36020": "Oak Harbor, WA",
  "36100": "Ocala, FL",
  "36180": "Ocean Pines, MD",
  "36220": "Odessa, TX",
  "36260": "Ogden, UT",
  "36340": "Oil City, PA",
  "36380": "Okeechobee, FL",
  "36420": "Oklahoma City, OK",
  "36460": "Olean, NY",
  "36500": "Olympia-Lacey-Tumwater, WA",
  "36540": "Omaha, NE-IA",
  "36580": "Oneonta, NY",
  "36620": "Ontario, OR-ID",
  "36660": "Opelousas, LA",
  "36700": "Orangeburg, SC",
  "36740": "Orlando-Kissimmee-Sanford, FL",
  "36780": "Oshkosh-Neenah, WI",
  "36820": "Oskaloosa, IA",
  "36830": "Othello, WA",
  "36837": "Ottawa, IL",
  "36840": "Ottawa, KS",
  "36900": "Ottumwa, IA",
  "36940": "Owatonna, MN",
  "36980": "Owensboro, KY",
  "37020": "Owosso, MI",
  "37060": "Oxford, MS",
  "37100": "Oxnard-Thousand Oaks-Ventura, CA",
  "37120": "Ozark, AL",
  "37140": "Paducah, KY-IL",
  "37220": "Pahrump, NV",
  "37260": "Palatka, FL",
  "37300": "Palestine, TX",
  "37340": "Palm Bay-Melbourne-Titusville, FL",
  "37420": "Pampa, TX",
  "37460": "Panama City-Panama City Beach, FL",
  "37500": "Paragould, AR",
  "37540": "Paris, TN",
  "37580": "Paris, TX",
  "37620": "Parkersburg-Vienna, WV",
  "37740": "Payson, AZ",
  "37800": "Pella, IA",
  "37860": "Pensacola-Ferry Pass-Brent, FL",
  "37900": "Peoria, IL",
  "37940": "Peru, IN",
  "37950": "Petoskey, MI",
  "37980": "Philadelphia-Camden-Wilmington, PA-NJ-DE-MD",
  "38060": "Phoenix-Mesa-Chandler, AZ",
  "38100": "Picayune, MS",
  "38180": "Pierre, SD",
  "38210": "Pikeville, KY",
  "38220": "Pine Bluff, AR",
  "38240": "Pinehurst-Southern Pines, NC",
  "38260": "Pittsburg, KS",
  "38300": "Pittsburgh, PA",
  "38340": "Pittsfield, MA",
  "38380": "Plainview, TX",
  "38420": "Platteville, WI",
  "38460": "Plattsburgh, NY",
  "38500": "Plymouth, IN",
  "38540": "Pocatello, ID",
  "38620": "Ponca City, OK",
  "38660": "Ponce, PR",
  "38700": "Pontiac, IL",
  "38740": "Poplar Bluff, MO",
  "38820": "Port Angeles, WA",
  "38860": "Portland-South Portland, ME",
  "38900": "Portland-Vancouver-Hillsboro, OR-WA",
  "38920": "Port Lavaca, TX",
  "38940": "Port St. Lucie, FL",
  "39020": "Portsmouth, OH",
  "39040": "Port Townsend, WA",
  "39060": "Pottsville, PA",
  "39150": "Prescott Valley-Prescott, AZ",
  "39220": "Price, UT",
  "39300": "Providence-Warwick, RI-MA",
  "39340": "Provo-Orem-Lehi, UT",
  "39380": "Pueblo, CO",
  "39420": "Pullman, WA",
  "39460": "Punta Gorda, FL",
  "39480": "Putnam, CT",
  "39500": "Quincy, IL-MO",
  "39540": "Racine-Mount Pleasant, WI",
  "39580": "Raleigh-Cary, NC",
  "39660": "Rapid City, SD",
  "39700": "Raymondville, TX",
  "39740": "Reading, PA",
  "39780": "Red Bluff, CA",
  "39820": "Redding, CA",
  "39860": "Red Wing, MN",
  "39900": "Reno, NV",
  "39940": "Rexburg, ID",
  "39960": "Rice Lake, WI",
  "39980": "Richmond, IN",
  "40060": "Richmond, VA",
  "40080": "Richmond-Berea, KY",
  "40090": "Rifle, CO",
  "40100": "Rio Grande City-Roma, TX",
  "40140": "Riverside-San Bernardino-Ontario, CA",
  "40180": "Riverton, WY",
  "40220": "Roanoke, VA",
  "40260": "Roanoke Rapids, NC",
  "40300": "Rochelle, IL",
  "40340": "Rochester, MN",
  "40380": "Rochester, NY",
  "40420": "Rockford, IL",
  "40460": "Rockingham, NC",
  "40540": "Rock Springs, WY",
  "40580": "Rocky Mount, NC",
  "40620": "Rolla, MO",
  "40660": "Rome, GA",
  "40700": "Roseburg, OR",
  "40740": "Roswell, NM",
  "40760": "Ruidoso, NM",
  "40770": "Russellville, AL",
  "40780": "Russellville, AR",
  "40820": "Ruston, LA",
  "40860": "Rutland, VT",
  "40900": "Sacramento-Roseville-Folsom, CA",
  "40940": "Safford, AZ",
  "40980": "Saginaw, MI",
  "41060": "St. Cloud, MN",
  "41100": "St. George, UT",
  "41140": "St. Joseph, MO-KS",
  "41180": "St. Louis, MO-IL",
  "41260": "St. Marys, PA",
  "41400": "Salem, OH",
  "41420": "Salem, OR",
  "41460": "Salina, KS",
  "41500": "Salinas, CA",
  "41540": "Salisbury, MD",
  "41620": "Salt Lake City-Murray, UT",
  "41660": "San Angelo, TX",
  "41700": "San Antonio-New Braunfels, TX",
  "41740": "San Diego-Chula Vista-Carlsbad, CA",
  "41760": "Sandpoint, ID",
  "41780": "Sandusky, OH",
  "41820": "Sanford, NC",
  "41860": "San Francisco-Oakland-Fremont, CA",
  "41940": "San Jose-Sunnyvale-Santa Clara, CA",
  "41980": "San Juan-Bayamón-Caguas, PR",
  "42020": "San Luis Obispo-Paso Robles, CA",
  "42100": "Santa Cruz-Watsonville, CA",
  "42140": "Santa Fe, NM",
  "42200": "Santa Maria-Santa Barbara, CA",
  "42220": "Santa Rosa-Petaluma, CA",
  "42300": "Sault Ste. Marie, MI",
  "42340": "Savannah, GA",
  "42380": "Sayre, PA",
  "42420": "Scottsbluff, NE",
  "42460": "Scottsboro, AL",
  "42540": "Scranton--Wilkes-Barre, PA",
  "42580": "Seaford, DE",
  "42620": "Searcy, AR",
  "42660": "Seattle-Tacoma-Bellevue, WA",
  "42680": "Sebastian-Vero Beach-West Vero Corridor, FL",
  "42700": "Sebring, FL",
  "42740": "Sedalia, MO",
  "42780": "Selinsgrove, PA",
  "42820": "Selma, AL",
  "42860": "Seneca, SC",
  "42900": "Seneca Falls, NY",
  "42940": "Sevierville, TN",
  "42980": "Seymour, IN",
  "43020": "Shawano, WI",
  "43060": "Shawnee, OK",
  "43100": "Sheboygan, WI",
  "43140": "Shelby-Kings Mountain, NC",
  "43180": "Shelbyville, TN",
  "43220": "Shelton, WA",
  "43260": "Sheridan, WY",
  "43300": "Sherman-Denison, TX",
  "43320": "Show Low, AZ",
  "43340": "Shreveport-Bossier City, LA",
  "43380": "Sidney, OH",
  "43420": "Sierra Vista-Douglas, AZ",
  "43460": "Sikeston, MO",
  "43500": "Silver City, NM",
  "43580": "Sioux City, IA-NE-SD",
  "43620": "Sioux Falls, SD-MN",
  "43640": "Slidell-Mandeville-Covington, LA",
  "43660": "Snyder, TX",
  "43700": "Somerset, KY",
  "43740": "Somerset, PA",
  "43760": "Sonora, CA",
  "43780": "South Bend-Mishawaka, IN-MI",
  "43890": "Sparta, WI",
  "43900": "Spartanburg, SC",
  "43940": "Spearfish, SD",
  "43980": "Spencer, IA",
  "44020": "Spirit Lake, IA",
  "44060": "Spokane-Spokane Valley, WA",
  "44100": "Springfield, IL",
  "44140": "Springfield, MA",
  "44180": "Springfield, MO",
  "44220": "Springfield, OH",
  "44260": "Starkville, MS",
  "44300": "State College, PA",
  "44340": "Statesboro, GA",
  "44420": "Staunton-Stuarts Draft, VA",
  "44460": "Steamboat Springs, CO",
  "44500": "Stephenville, TX",
  "44540": "Sterling, CO",
  "44580": "Sterling, IL",
  "44620": "Stevens Point-Plover, WI",
  "44660": "Stillwater, OK",
  "44700": "Stockton-Lodi, CA",
  "44740": "Storm Lake, IA",
  "44780": "Sturgis, MI",
  "44860": "Sulphur Springs, TX",
  "44900": "Summerville, GA",
  "44940": "Sumter, SC",
  "44980": "Sunbury, PA",
  "45000": "Susanville, CA",
  "45020": "Sweetwater, TX",
  "45060": "Syracuse, NY",
  "45140": "Tahlequah, OK",
  "45180": "Talladega-Sylacauga, AL",
  "45220": "Tallahassee, FL",
  "45300": "Tampa-St. Petersburg-Clearwater, FL",
  "45340": "Taos, NM",
  "45380": "Taylorville, IL",
  "45460": "Terre Haute, IN",
  "45500": "Texarkana, TX-AR",
  "45520": "The Dalles, OR",
  "45580": "Thomaston, GA",
  "45620": "Thomasville, GA",
  "45660": "Tiffin, OH",
  "45700": "Tifton, GA",
  "45740": "Toccoa, GA",
  "45780": "Toledo, OH",
  "45820": "Topeka, KS",
  "45860": "Torrington, CT",
  "45880": "Town of Pecos, TX",
  "45900": "Traverse City, MI",
  "45940": "Trenton-Princeton, NJ",
  "45980": "Troy, AL",
  "46020": "Truckee-Grass Valley, CA",
  "46060": "Tucson, AZ",
  "46100": "Tullahoma-Manchester, TN",
  "46140": "Tulsa, OK",
  "46180": "Tupelo, MS",
  "46220": "Tuscaloosa, AL",
  "46300": "Twin Falls, ID",
  "46340": "Tyler, TX",
  "46380": "Ukiah, CA",
  "46460": "Union City, TN",
  "46500": "Urbana, OH",
  "46520": "Urban Honolulu, HI",
  "46540": "Utica-Rome, NY",
  "46580": "Utuado, PR",
  "46620": "Uvalde, TX",
  "46660": "Valdosta, GA",
  "46700": "Vallejo, CA",
  "46780": "Van Wert, OH",
  "46820": "Vermillion, SD",
  "46860": "Vernal, UT",
  "46900": "Vernon, TX",
  "46980": "Vicksburg, MS",
  "47020": "Victoria, TX",
  "47080": "Vidalia, GA",
  "47180": "Vincennes, IN",
  "47220": "Vineland, NJ",
  "47240": "Vineyard Haven, MA",
  "47260": "Virginia Beach-Chesapeake-Norfolk, VA-NC",
  "47300": "Visalia, CA",
  "47340": "Wabash, IN",
  "47380": "Waco, TX",
  "47420": "Wahpeton, ND-MN",
  "47460": "Walla Walla, WA",
  "47540": "Wapakoneta, OH",
  "47580": "Warner Robins, GA",
  "47620": "Warren, PA",
  "47660": "Warrensburg, MO",
  "47700": "Warsaw, IN",
  "47780": "Washington, IN",
  "47820": "Washington, NC",
  "47900": "Washington-Arlington-Alexandria, DC-VA-MD-WV",
  "47920": "Washington Court House, OH",
  "47930": "Waterbury-Shelton, CT",
  "47940": "Waterloo-Cedar Falls, IA",
  "47980": "Watertown, SD",
  "48020": "Watertown-Fort Atkinson, WI",
  "48060": "Watertown-Fort Drum, NY",
  "48140": "Wausau, WI",
  "48180": "Waycross, GA",
  "48200": "Waynesville, NC",
  "48220": "Weatherford, OK",
  "48260": "Weirton-Steubenville, WV-OH",
  "48300": "Wenatchee-East Wenatchee, WA",
  "48460": "West Plains, MO",
  "48540": "Wheeling, WV-OH",
  "48580": "Whitewater-Elkhorn, WI",
  "48620": "Wichita, KS",
  "48660": "Wichita Falls, TX",
  "48680": "Wildwood-The Villages, FL",
  "48700": "Williamsport, PA",
  "48780": "Williston, ND",
  "48820": "Willmar, MN",
  "48900": "Wilmington, NC",
  "48940": "Wilmington, OH",
  "48980": "Wilson, NC",
  "49010": "Winchester, TN",
  "49020": "Winchester, VA-WV",
  "49080": "Winnemucca, NV",
  "49100": "Winona, MN",
  "49180": "Winston-Salem, NC",
  "49220": "Wisconsin Rapids-Marshfield, WI",
  "49260": "Woodward, OK",
  "49300": "Wooster, OH",
  "49340": "Worcester, MA",
  "49380": "Worthington, MN",
  "49420": "Yakima, WA",
  "49460": "Yankton, SD",
  "49620": "York-Hanover, PA",
  "49660": "Youngstown-Warren, OH",
  "49700": "Yuba City, CA",
  "49740": "Yuma, AZ",
  "49780": "Zanesville, OH",
  "49820": "Zapata, TX",
};

// Metropolitan/Micropolitan Area Title -> CBSA Code (reverse lookup)
export const metroToCbsa: Record<string, string> = Object.fromEntries(
  Object.entries(cbsaToMetro).map(([code, name]) => [name, code]),
);

// Helper: Get all CBSAs by primary state abbreviation
export const cbsaByState: Record<string, string[]> = (() => {
  const byState: Record<string, string[]> = {};
  for (const [code, name] of Object.entries(cbsaToMetro)) {
    const match = name.match(/,\s*([A-Z]{2})/);
    if (match) {
      const state = match[1];
      if (!byState[state]) byState[state] = [];
      byState[state].push(code);
    }
  }
  for (const state of Object.keys(byState)) {
    byState[state].sort();
  }
  return byState;
})();

// Type definitions
export type CbsaCode = keyof typeof cbsaToMetro;
export type MetroName = (typeof cbsaToMetro)[CbsaCode];
